module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/stories_banner-28ecacfd33e101045853d7eaa8c20563.png";